import React from 'react'

export default function AuthClose({ onClick }) {
    return (
        <div className="auth__close" onClick={onClick}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 1L1 17M17 17L1 1" stroke="#595959" strokeWidth="2" strokeLinecap="round" />
            </svg>
        </div>
    )
}
